export default __webpack_public_path__ + "static/media/Software-Gestao-Creditos.6f6f93a8.png";